// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { Button as BSButton } from 'reactstrap';
import { Icon } from 'trustar-2.0/components';
import { ThemeColors } from 'trustar-2.0/themes/default';
import type { ColorType } from 'trustar-2.0/types';
import { pick } from 'ramda';
import {
  Input as BSInput,
  InputGroupAddon as BSInputGroupAddon,
  InputGroup as BSInputGroup,
} from 'reactstrap';

type InputPropType = {
  children: ?Node,
  // type can be things like text, password, (typical input types) as well as select and textarea, providing children as you normally would to those.
  type: string,
  bsSize: 'lg' | 'sm',
  valid: boolean,
  invalid: boolean,
  inline: boolean,
  checked: ?boolean,
  tag: ?(Function | string),
  innerRef: ?(Function | string),
  plaintext: boolean,
  addon: boolean,
  className: string,
  icon: ?string,
  onChange: ?Function,
  onClick: ?Function,
  name: ?string,
  value: ?string,
  disabled: ?string,
  autoComplete: ?string,
  placeholder: ?string,
  dataCy?: string,
  ariaLabel?: string, // Hmm, TODO, more global acceptance for aria labels NOT as props
};

const inputDefaultProps = {
  width: '2rem',
  type: 'text',
  bsSize: 'lg',
  valid: false,
  invalid: false,
  inline: false,
  tag: 'input',
  plaintext: false,
  addon: false,
  className: '',
  name: '',
  disabled: false,
};
export const Input = (props: InputPropType) => {

  // $FlowFixMe: Ramda flow error.
  const inputProps = pick([
    'width',
    'type',
    'bsSize',
    'valid',
    'invalid',
    'tag',
    'plaintext',
    'addon',
    'className',
    'onChange',
    'onClick',
    'onKeyPress',
    'name',
    'value',
    'checked',
    'disabled',
    'autoComplete',
    'placeholder',
    'aria-label',
    'dataCy',
  ], props);
  // I am skipping styled-components because
  // it's causing input lag issues when we try to
  // implement as a controlled component.
  return (<BSInput data-cy={props.dataCy || props.name} style={{
    display: props.inline ? 'inline' : 'block',
    verticalAlign: 'middle',
  }} {...inputProps} />);
};

Input.defaultProps = inputDefaultProps;

// $FlowFixMe Weird flow error on InputPropType
export const IconInput = (props: InputPropType) => {
  const IconAddon = styled(BSInputGroupAddon)`
    && {
      padding: .5rem;
      font-size: 1.6rem;
      line-height: 2.1rem;
      color: grey;
      background-color: ${ props.disabled ? '#e9ecef' : 'white' } ;
      vertical-align: middle;
      border-left: none;
      border: 1px solid #ced4da;
      box-sizing: border-box;
      border-top: 1px;
      border-bottom: 1px;
    }
  `;

  // $FlowFixMe: Ramda flow error.
  const inputProps = pick([
    'width',
    'type',
    'bsSize',
    'valid',
    'invalid',
    'inline',
    'tag',
    'plaintext',
    'addon',
    'className',
    'icon',
    'onChange',
    'onKeyPress',
    'value',
    'name',
    'disabled',
    'autoComplete',
    'placeholder',
    'aria-label',
  ], props);

  return (
    <BSInputGroup>
      <Input {...inputProps} data-cy={props.dataCy || props.name}/>
      <IconAddon addonType='append'>
        <Icon fontSize={props.bsSize === 'lg' ? '2rem' : '1.5rem'} icon={props.icon} />
      </IconAddon>
    </BSInputGroup>
  );
};

IconInput.defaultProps = inputDefaultProps;

export default Input;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Form/Input.js